import React from 'react';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import { IconButton } from '@mui/material';
import axios from 'axios';
import { FILE_TYPE_NAMES } from '../../config/constant';
import { useQuantityContext } from '../QuantityContext';

function FileDragUpload({
  maxSize,
  inputId,
  uploadIcon: UploadIcon = AddCircleRoundedIcon,
  iconSize = 24,
  maxSizeWarning = true,
  contextUpdate,
  accept,
  setOpenModal }) {
  // const { updateAttachDocs } = useCreateCardDetailContext();

  const { handleFailure, handleInfo } = useQuantityContext();
  const maxSizeInBytes = maxSize * 1024 * 1024; // Convert MB to bytes

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      validateAndUploadFile(file);
    } else { }
    // Reset the file input value to allow re-uploading the same file
    event.target.value = null;
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const file = event.dataTransfer.files[0];
    if (file) {
      validateAndUploadFile(file);
    } else { }
  };

  const validateAndUploadFile = async (file) => {
    if (file && accept.includes(file.type)) {
      {
        setOpenModal &&
          setOpenModal(false);
      }
      if (file.size <= maxSizeInBytes) {
        // const reader = new FileReader();
        // reader.onloadend = () => {
        //   const base64format = reader.result;
        //   const tempdata = base64format.split(",")[1];

        try {
          // const formData = new FormData();
          // formData.append('file', file);

          // const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/uploadpublicblob/generate-sas-url`, formData, {
          //   headers: {
          //     'Content-Type': 'multipart/form-data',
          //   },
          // });

          // const { url } = response.data;
          const objectUrl = URL.createObjectURL(file);

          const fileObject = {
            name: file.name || 'file',
            size: formatFileSize(file.size), // Ensure size is formatted
            date: new Date().toLocaleDateString(), // Add date
            type: getFileType(file.name),
            data: objectUrl,
            fileCat: getFileCategory(file.name)
          };

          if (contextUpdate && (contextUpdate.name === 'updateMedicalAttachments' || contextUpdate.name === 'updateVerifyExpDocs')) {  // I made this logic because It Some context I dont want to save like AttachDoc.Image like this

            contextUpdate(fileObject)
            // console.log("File Upload Component", fileObject);
          } else {
            const fileCat = getFileCategory(file.name);
            contextUpdate(fileObject, fileCat);
          }
          // };
          // reader.readAsDataURL(file);
        } catch (error) {
          // console.error('Error uploading file:', error);
          // alert('Error uploading file. Please try again.');
          handleFailure("Error uploading file. Please try again.");
        }

      } else {
        // alert(`File size must be ${maxSize} or less.`);
        handleInfo(`File size must be ${maxSize} or less.`);
      }
    } else {
      // Map MIME types to their short names
      const shortNames = accept.map(type => FILE_TYPE_NAMES[type] || type);

      // alert(`Invalid file type. Only ${shortNames.join(", ")} are allowed.`);
      handleInfo(`Invalid file type. Only ${shortNames.join(", ")} are allowed.`);
    }
  };

  const getFileType = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg';
      case 'png':
        return 'image/png';
      case 'gif':
        return 'image/gif';
      case 'mp4':
        return 'video/mp4';
      case 'mov':
        return 'video/quicktime';
      case 'avi':
        return 'video/x-msvideo';
      case 'mpg':
      case 'mpeg':
        return 'video/mpeg';
      case 'pdf':
        return 'application/pdf';
      case 'doc':
      case 'docx':
        return 'application/msword';
      case 'ppt':
      case 'pptx':
        return 'application/vnd.ms-powerpoint';
      case 'xls':
      case 'xlsx':
        return 'application/vnd.ms-excel';
      case 'onetoc':
      case 'onetoc2':
      case 'onetmp':
      case 'onepkg':
        return 'application/onenote';
      case 'gsheet':
        return 'application/vnd.google-apps.spreadsheet';
      case 'gdoc':
        return 'application/vnd.google-apps.document';
      default:
        return 'application/octet-stream';
    }
  };

  const getFileCategory = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) {
      return 'images';
    } else if (['mp4', 'mov', 'avi', 'mpg', 'mpeg'].includes(extension)) {
      return 'videos';
    } else {
      return 'others';
    }
  };

  // const getFileType = (fileName) => {
  //   const extension = fileName.split('.').pop().toLowerCase();
  //   if (extension.startsWith('jpg') || extension.startsWith('jpeg') || extension.startsWith('png') || extension.startsWith('gif')) {
  //     return 'images';
  //   } else if (extension.startsWith('mp4') || extension.startsWith('mov') || extension.startsWith('avi')) {
  //     return 'videos';
  //   } else {
  //     return 'others';
  //   }
  // };

  const formatFileSize = (size) => {
    if (size >= 1000000) {
      // console.log("Added the image data", size);
      return `${(size / 1000000).toFixed(1)} Mb`;
    } else {
      return `${(size / 1000).toFixed(0)} Kb`;
    }
  };

  return (
    <div className='add-logo-container text-center'
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDrop}>
      <div className="file-upload-container" onClick={() => document.getElementById(inputId).click()}>
        <IconButton color="inherit" disableTouchRipple>
          <UploadIcon sx={{ height: iconSize, width: iconSize }} />
        </IconButton>
        <span className='mb-0'>Drag file here or <strong>Upload File</strong></span>
        {maxSizeWarning && <div className='tertiary-text'>{maxSize} Mb Max File Size</div>}
        <input id={inputId} accept={accept.join(",")} type="file" style={{ display: 'none' }} onChange={handleFileChange} />
      </div>
    </div>
  );
}

export default FileDragUpload;
